import type { CategoryResourceReadApi } from '@ingenico/api-sdk-configuration-public';
import { toString } from 'lodash-es';
import type { SmartFieldCategory, SmartFieldCategoryOption } from '../domain/models/smartFields.model';

export function transformCategoryDataToOptions(categoryData?: SmartFieldCategory[]): SmartFieldCategoryOption[] {
  if (!categoryData) {
    return [];
  }

  return categoryData.map((category) => ({
    id: toString(category?.id),
    label: toString(category?.name),
  }));
}

export function transformMixedValuesToCategoryOptions(
  values: (SmartFieldCategoryOption | string)[] | null,
  availableCategories?: SmartFieldCategoryOption[],
): SmartFieldCategoryOption[] {
  const categories = availableCategories || [];
  if (!values) {
    return [];
  }

  return values.map((item) => {
    if (typeof item === 'string') {
      const existingCategory = categories.find((cat) => cat.label.toLowerCase() === item.toLowerCase());

      if (existingCategory) {
        return existingCategory;
      }

      return { id: item, label: item };
    }
    return item;
  });
}

export function isNewlyCreatedCategory(category: SmartFieldCategoryOption): boolean {
  return category.id === category.label;
}

export function isValidApiCategory(cat: CategoryResourceReadApi): cat is Required<CategoryResourceReadApi> {
  return Boolean(cat.id && cat.name);
}
